import { AppIcon, AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppQuantumChat from "@toothfairy/shared-ui/AppQuantumChat";
import AppDropDown from "@toothfairy/shared-ui/AppDropDown";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useEffect, useState } from "react";
import { Popable } from "react-native-popable";
import { View, useWindowDimensions } from "react-native";
import { appDimensions } from "../MainViewContainer";
import { useHistory } from "../../Router";
import { useModels } from "../Common/baseModels";
import { useTranslation } from "react-i18next";

const AgentScreen = ({
  messages,
  setMessages,
  user,
  handleSend = () => {},
  onQuestionPress,
  placeholder,
  agentTitle = "ToothFairyAI",
  textToDisplayWhileLoading = "**...**",
  disclaimer,
  isMessagesLoaded,
  languages,
  onLanguageChange = () => {},
  selectedLanguage,
  isAIStreaming,
  showTitle = false,
  onCancel = () => {},
  inputText,
  setInputText,
  loadingMessageId,
  isLoading,
  S3downloadUrlRequest = () => {},
  handleFeedback = () => {},
  agentImage,
  agentColor,
  allowFeedback = false,
  agentLogo,
  allowStop = false,
  isAgentFetched,
  isLastMessageEmpty,
  showDarkMode = true,
  showReloadInDisclosure = true,
  coder = false,
  workspaceId,
  workspace,
  quickQuestions,
  showSplash = false,
  splashTitle,
  logoBackground,
  showTimeForResponse,
  showDetectedLanguage,
  setWinner,
  isWinner,
  agentId,
  _agentName,
  setAgent,
  onAgentChange = () => {},
}) => {
  const { t } = useTranslation();
  const _placeholder = placeholder || t("arena.placeholder");
  const _disclaimer = disclaimer || t("arena.disclaimer");
  const history = useHistory();
  const { currentTheme } = AppTheme.useTheme();
  const { height } = useWindowDimensions();
  const [outputString, setOutputString] = useState("");
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const { state, dispatch } = AppStateManager.useAppStateManager();
  const [composerReady, setComposerReady] = useState(false);
  const { baseModels: _baseModels } = useModels();
  const _reasoningModels = _baseModels
    ?.filter((u) => u?.reasoner)
    ?.map((u) => u?.id);
  const [
    suppressDisabledPlaceholder,
    setSuppressDisabledPlaceholder,
  ] = useState(true);
  const [agentName, setAgentName] = useState("");
  useEffect(() => {
    setAgentName(_agentName);
  }, [agentId, _agentName]);

  useEffect(() => {
    if (isMessagesLoaded && currentCharIndex < placeholder?.length) {
      const timer = setTimeout(() => {
        setOutputString(
          (prevOutput) => prevOutput + placeholder[currentCharIndex],
        );
        setCurrentCharIndex((prevIndex) => prevIndex + 1);
      }, 1);

      return () => clearTimeout(timer);
    } else if (currentCharIndex === placeholder?.length) {
      setComposerReady(true);
      setSuppressDisabledPlaceholder(false);
    }
  }, [placeholder, currentCharIndex, isMessagesLoaded]);

  return (
    <div
      className="tf-chat-arena-container"
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-end",
        flex: 1,
        flexDirection: "column",
        backgroundColor: currentTheme?.theme?.backgroundColor,
        borderRadius: 10,
        border: `0.5px solid ${currentTheme?.theme?.border_color}`,
        maxWidth: "50%",
        height: "100%",
      }}
    >
      <div
        className="tf-agent-header"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          marginBottom: 10,
          marginHorizontal: 5,
          alignSelf: "flex-start",
        }}
      >
        <Popable
          numberOfLines={2}
          backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
          style={[
            {
              top: 30,
              zIndex: 20,
              maxWidth: 300,
            },
          ]}
          content={t("arena.markAsWinner")}
          action="hover"
          position="bottom"
        >
          <AppIcon
            icon={AppAssets?.icons?.thumbsUp}
            wrapperStyle={{
              marginLeft: 10,
              marginBottom: 3,
            }}
            color={
              isWinner
                ? currentTheme?.theme?.primary
                : currentTheme?.theme?.mediumGrey
            }
            size={16}
            isClickable
            onPress={() => {
              setWinner(agentId);
            }}
          />
        </Popable>

        <Popable
          numberOfLines={2}
          backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
          style={[
            {
              top: 30,
              zIndex: 20,
              maxWidth: 300,
            },
          ]}
          content={t("arena.goToConfig")}
          action="hover"
          position="bottom"
        >
          <AppIcon
            icon={AppAssets?.icons?.experimentAgent}
            wrapperStyle={{
              marginLeft: 10,
              marginBottom: 3,
            }}
            color={currentTheme?.theme?.primary}
            size={16}
            isClickable
            onPress={() => {
              history.push(`/workspaces/${workspaceId}/agents/${agentId}`);
            }}
          />
        </Popable>

        <AppDropDown
          dropDownStyle={{
            width: 315,
            marginLeft: 5,
            borderColor: currentTheme?.theme?.transparent,
            fontWeight: "bold",
            fontFamily: "boldFont",
          }}
          isElevated={false}
          dropdownIconColor="transparent"
          items={state?.agents
            ?.filter((u) => ["chatter", "coder", "retriever"].includes(u?.mode))
            ?.map((u) => {
              return {
                label: u?.label,
                id: u?.id,
              };
            })}
          propertyLabel="label"
          propertyValue="id"
          selectedValue={agentId}
          onValueChange={(itemValue, itemIndex) => {
            setAgent({ id: itemValue });
          }}
        />
      </div>

      <div
        style={{
          minHeight: state?.isChatOpen ? 100 : 50,
          width: "100%",
          paddingTop: 5,
        }}
        className="tf-chat-widget"
      >
        <div className="tf-agent">
          <View
            style={{
              flex: 1,
              height: "100%",
              marginTop: 5,
              paddingHorizontal: 5,
            }}
          >
            {/* <View
                  style={{
                    width: appDimensions().width < 1500 && "100%",
                    paddingTop: isMobileScreen() ? 10 : 60,
                    justifyContent: "space-between",
                    backgroundColor:
                      currentTheme?.theme?.website_contrast_background_color_opaque,
                  }}
                >
                  <FaqBadge onQuestionPress={onQuestionPress} />
                  <SettingsBadge
                    languages={languages}
                    onLanguageChange={onLanguageChange}
                    selectedLanguage={selectedLanguage}
                  />
                </View> */}
            <View
              style={{
                flexDirection: "row",
                alignSelf: "flex-start",
              }}
            >
              {showTitle && (
                <AppText
                  style={{
                    fontSize: currentTheme?.theme?.largest_font_size,
                  }}
                  fontWeight="bold"
                  wrapperStyle={{
                    marginTop: 0,
                    alignSelf: appDimensions().width < 860 && "flex-start",
                  }}
                  color={currentTheme?.theme?.primary}
                >
                  {t("arena.askAgent", { agent: agentTitle })}
                </AppText>
              )}
            </View>

            <div className="tf-chat-container">
              <AppQuantumChat
                agentDefaultIcon={
                  agentImage || require("../../assets/favicon.png")
                }
                customChartingConfig={workspace?.customChartingConfig}
                coder={true}
                isChatEmpty={
                  showSplash ? messages?.length == 0 : messages?.length == 1
                }
                sendOnEnter
                renderMarkdown
                isWidget
                workspaceid={workspaceId}
                loadEarlier={false}
                messages={messages}
                setMessages={setMessages}
                onSendEvent={handleSend}
                user={{
                  id: user?.id,
                  name: user?.username,
                }}
                hideReasoning={true}
                agentColor={agentColor || currentTheme?.theme?.primary}
                chatStyle={{
                  height: height - 305,
                }}
                showSplash={showSplash}
                showDuration={showTimeForResponse}
                showLanguage={showDetectedLanguage}
                splashTitle={splashTitle}
                inverted={false}
                showUserAvatar
                messagesContainerStyle={{
                  marginTop: -10,
                }}
                renderAvatarOnTop
                isDayDisplayed={false}
                allowFeedback={allowFeedback}
                handleFeedback={handleFeedback}
                maxComposerHeight={60}
                composerHeight={60}
                sortOrder="asc"
                placeholderDisabled={t("arena.agentResponding")}
                isComposerDisabled={!composerReady || isAIStreaming}
                textColor={"darkGrey"}
                isTyping={true}
                showIconForGenericUser
                textToDisplayWhileLoading={textToDisplayWhileLoading}
                onCancel={onCancel}
                inputText={inputText}
                setInputText={setInputText}
                renderWithVanillaInput={false}
                onLoadEarlier={() => {}}
                S3downloadUrlRequest={S3downloadUrlRequest}
              ></AppQuantumChat>
            </div>
          </View>
        </div>
      </div>
    </div>
  );
};

export default AgentScreen;
